/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CreateJiraIssueWrapper = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: ${token('space.100', '8px')};
  max-width: ${gridSize() * 110}px;
`;

export const CreateJiraIssueActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${token('color.text.subtlest', colors.N200)};
`;

export const CreateJiraIssueActionsInnerContainer = styled.div`
  display: flex;
  align-items: center;

  /* Need to set an explicit white background here so that SpotlightTarget
  component uses the correct background color when onboarding is shown. */
  background-color: ${token('color.background.input', colors.N0)};
`;

export const CancelButton = styled(Button)`
  padding-right: 0;
`;

export const SubmitButton = styled(Button)`
  padding-right: 0;
`;

export const CreateIssueSpinnerWrapper = styled.div`
  margin-right: ${token('space.050', '4px')};
`;
